interface ExchangeShapedProduct {
  exchange_for?: unknown;
  exchangeGroupItem?: unknown;
}

interface ExchangeShapedReturn {
  products: ExchangeShapedProduct[];
  advancedExchangeItems?: unknown[] | null;
}

/** A product the shopper swapped for a different variant of the same product. */
export function isVariantExchangeProduct(
  product: ExchangeShapedProduct,
): boolean {
  return !!product.exchange_for || !!product.exchangeGroupItem;
}

/** Whether the return carries any exchange items, variant or advanced. */
export function hasExchangeItems(return_: ExchangeShapedReturn): boolean {
  return (
    (return_.advancedExchangeItems?.length ?? 0) > 0 ||
    return_.products.some(isVariantExchangeProduct)
  );
}
